import dashify from 'dashify';
/**
 * Uppercase the first character in a string
 *
 * @param str String to modify
 */
export const firstToUpperCase = (str) => str[0].toUpperCase() + str.substring(1);
/**
 * Lowercase the first character in a string
 *
 * @param str String to modify
 */
export const firstToLowerCase = (str) => str[0].toLowerCase() + str.substring(1);
/**
 * Convert a string to camelCase
 *
 * @param str String to modify
 */
export const toCamelCase = (str) => {
    const [firstWord, ...words] = str
        .replace(/[^(\d\w)]/g, ' ')
        .split(' ');
    return firstToLowerCase(firstWord) + words.map(firstToUpperCase).join('');
};
/**
 * Convert a string to kebab-case
 *
 * @param str String to modify
 */
export const toKebabCase = (str) => dashify(str);
